import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stat-box" }
const _hoisted_2 = { class: "sum-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", {
      class: "percent",
      style: _normalizeStyle({color: _ctx.color})
    }, _toDisplayString(_ctx.percent ? `${_ctx.percent.toLocaleString(undefined, { style: 'percent' })}` : 'N/A'), 5),
    _createElementVNode("p", null, _toDisplayString(_ctx.amount ? `${_ctx.amount.toFixed(0)} ${_ctx.type} in total` : 'N/A'), 1)
  ]))
}